import { trigger, state, transition, animate, style } from '@angular/animations';

export class Animations {
    
    public static collapseInOut = trigger('collapseInOut', [       
        state('true', style({ height: '0px', display: 'none' })),
        state('false', style({ height: '*' })),
        transition('true => false', animate('300ms ease-in')),
        transition('false => true', animate('300ms ease-out'))
    ]);

    public static flyInOut = trigger('flyInOut', [
        state('in', style({ transform: 'translateX(0)' })),
        transition('void => *', [
            style({ transform: 'translateX(200%)' }),
            animate(700)
        ]),
        transition('* => void', [
            animate(700, style({ transform: 'translateX(-200%)' }))
        ])
    ])
    
}

//export const Scrollup = trigger('Scrollup', [
//    // transition('1 => 0', animate('500ms ease-in')),
//    // transition('0 => 1', animate('500ms ease-out'))

//    transition('void => *', [
//        style({ transform: 'translateY(-100%)' }), 
//        animate(700)
//    ]),
//    transition('* => void', [
//        animate(700, style({ transform: 'translateY(100%)' }))
//    ])
//]);